import type { OffersTranslation } from './types';

export const offersHi: OffersTranslation = {
  title: 'आपको पेश की गई',
  intro: 'स्वीकार करें तो चैट आपकी हो जाएगी। मना करें या समय खत्म हो जाए, तो यह अगले व्यक्ति को जाएगी।',
  timeLeft: '{{time}} बाकी',
  timeLeftLabel: 'स्वीकार करने के लिए बचा समय: {{time}}',
  timeUp: 'समय खत्म',
  round: '3 में से पेशकश {{round}}',
  accept: 'स्वीकार करें',
  acceptName: '{{name}} के साथ चैट स्वीकार करें',
  decline: 'मना करें',
  declineName: '{{name}} के साथ चैट के लिए मना करें',
  accepted: '{{name}} के साथ चैट अब आपकी है।',
  declined: 'आपने {{name}} के साथ चैट के लिए मना किया। यह अगले व्यक्ति को जाएगी।',
  closed: 'यह पेशकश अब खुली नहीं है।',
  offeredTo: '{{name}} को पेश की गई · {{time}}',
  offeredToYou: 'आपको पेश की गई · {{time}}',
  declineDialog: {
    title: 'इस चैट के लिए मना करें',
    description:
      'यह अगले उस व्यक्ति को पेश की जाएगी जो इसे ले सकता है। आपका कारण रखा जाता है ताकि टीम लीड काम बाँट सकें।',
    reason: 'आप मना क्यों कर रहे हैं?',
    reasonMissing: 'कोई कारण चुनें।',
    reasons: {
      at_capacity: 'अभी मेरे पास बहुत चैट हैं',
      not_my_area: 'यह मेरा क्षेत्र नहीं है',
      going_offline: 'मैं ऑफ़लाइन जा रहा हूँ',
      other: 'कुछ और',
    },
    goingOfflineHint: 'आपकी स्थिति "दूर" हो जाएगी, ताकि आपको और चैट पेश न की जाएँ।',
    note: 'नोट',
    noteHint: 'वैकल्पिक। आपके टीम लीड इसे पढ़ सकते हैं।',
    submit: 'चैट के लिए मना करें',
  },
  load: '{{max}} में से {{open}} चैट',
  loadNoLimit: '{{open}} खुली चैट',
  team: {
    summaryQueue: 'नई चैट टीम की कतार में इंतज़ार करती हैं, कोई भी ले सकता है।',
    summaryOffer: 'नई चैट एक बार में एक व्यक्ति को पेश की जाती हैं, हर एक को {{seconds}} सेकंड।',
    edit: 'चैट कैसे पहुँचती हैं',
    editName: '{{team}} में चैट पहुँचने का तरीका बदलें',
    title: '{{team}} में चैट कैसे पहुँचती हैं',
    description: 'चुनें कि इस टीम को सौंपी गई चैट उसके लोगों तक कैसे पहुँचे।',
    mode: 'जब टीम के पास कोई चैट आए',
    modes: {
      queue: 'सभी देखें',
      queueHint: 'यह टीम की कतार में इंतज़ार करती है और टीम का कोई भी व्यक्ति इसे लेता है।',
      offer: 'एक बार में एक व्यक्ति को पेश करें',
      offerHint:
        'यह ऑनलाइन सबसे उपयुक्त व्यक्ति को पेश की जाती है: जो अपनी सीमा से कम हो, ग्राहक की भाषा बोलता हो और जिसके पास सबसे कम खुली चैट हों। अगर वे मना करें या समय पर जवाब न दें, तो अगले व्यक्ति को पेश की जाती है। तीन लोगों के बाद यह कतार में इंतज़ार करती है। इस बीच कोई भी इसे ले सकता है।',
    },
    timeout: 'स्वीकार करने के लिए सेकंड',
    timeoutHint: '15 से 600 सेकंड।',
    timeoutInvalid: '15 से 600 तक सेकंड की संख्या लिखें।',
    save: 'सहेजें',
    saved: '{{team}} में चैट पहुँचने का तरीका सहेजा गया।',
  },
  people: {
    title: 'भाषाएँ और सीमाएँ',
    description:
      'चैट पहले उन लोगों को पेश की जाती हैं जो ग्राहक की भाषा बोलते हैं, और कभी उसे नहीं जो अपनी सीमा पर हो।',
    none: 'कोई भाषा नहीं दी गई',
    noLimit: 'कोई सीमा नहीं',
    limit: 'अधिकतम {{max}} खुली चैट',
    edit: 'बदलें',
    editName: '{{name}} की भाषाएँ और सीमा बदलें',
    dialogTitle: '{{name}} की भाषाएँ और सीमा',
    languages: 'वे किन भाषाओं में जवाब देते हैं',
    max: 'एक साथ अधिकतम खुली चैट',
    maxHint: '1 से 50 तक। कोई सीमा न रखनी हो तो खाली छोड़ें।',
    maxInvalid: '1 से 50 तक कोई संख्या लिखें, या खाली छोड़ें।',
    save: 'सहेजें',
    saved: '{{name}} की भाषाएँ और सीमा सहेजी गईं।',
    loading: 'भाषाएँ और सीमाएँ लोड हो रही हैं',
  },
};
